import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z"
}), 'HomeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HomeSharp.js
// module id = 4148
// module chunks = 2